function getFileNameWithoutExtension(fullFileName) {
    const lastDotIndex = fullFileName.lastIndexOf('.');

    if (lastDotIndex === -1) return fullFileName; // No extension found

    return fullFileName.substring(0, lastDotIndex);
}
export const get_api = (reqUrl) => {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Access-Token", "2312");
    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch("http://192.168.1.140:8007" + reqUrl, requestOptions)
        .then(response => {
            if (response.status !== 200) {
                return response.json().then(ret => {
                    throw new Error('HTTP ERROR: ' + ret);
                });
            } else {
                return response.json()
            }
        })
        .then(result => {
            console.log(result)
            return result.result;
        })
        .catch(error => console.log('error', error));
}
export const post_api_upload = (name, md5 = '11111111111111111111111111111111', file) => {
    var myHeaders = new Headers();
    // myHeaders.append("Accept", "application/json");
    // myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Access-Token", "2312");
    myHeaders.append("Filename", name);
    myHeaders.append("IDcard", md5);
    const formData = new FormData();
    formData.append('file', file);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
    };

    return fetch("http://192.168.1.140:8008/storage/store/file", requestOptions)
        .then(res => res.json())
        .then(result => {
            console.log(result)
            if (result.code === 200) {
                return result.result;
            } else if (result.code === 444) {
                window.alert('You have uploaded the same file before!')
                throw new Error('HTTP ERROR');
            } else {
                window.alert('Server side error!')
                throw new Error('HTTP ERROR');
            }
        }).then(result => {
            console.log(result)
            return result?.storage_id;
        })
        .then(async (id) => {
            const data = {
                storage_id: id,
                name: getFileNameWithoutExtension(name),
                description: 'My Uploaded Arts'
            }
            await post_api_upload_step2(data)
        })
        .catch(error => console.log('error', error));
}

const post_api_upload_step2 = (data) => {
    return fetch('http://192.168.1.140:8007/artwork/upload/private/artwork', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => console.log(data))
        .then(data => {
            window.alert('Success!')
        })
        .catch(error => console.error('Error:', error));
}
export const post_api = (reqUrl, data) => {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Access-Token", "2312");

    var raw = JSON.stringify(data);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch("http://192.168.1.140:8007" + reqUrl, requestOptions)
        .then(response => {
            if (response.status === 422) {
                return response.json().then(ret => {
                    window.alert('Value Error' + ret.detail[0]['msg']);
                    throw new Error('HTTP ERROR 422: ' + ret.detail[0]['msg']);
                });
            } else {
                return response.json()
            }
        })
        .then(result => {
            if (result.code === 200) {
                window.alert('Success!')
            } else {
                window.alert('Server side error!')
            }
            return result.result;
        })
}
